import Portal from 'client/widget-components/components/Portal';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { useBookingContext } from '../../../Context';
import { BookerStateContext } from '../../../hooks/useRuntimeCalBookingState';
import { CalBookerStep } from '../../../types';
import BackButton from '../../BackButton';

interface BookerBackButtonProps {
    calBookerStep: CalBookerStep | null;
    containerClassName: string;
}

const BookerBackButton = ({
    calBookerStep,
    containerClassName,
}: BookerBackButtonProps) => {
    const bookerContext = useBookingContext();
    const [bookingState, bookingActions] = useContext(BookerStateContext);
    const [rootEl, setRootEl] = useState<HTMLElement | null>(null);
    const isMultipleEvents = bookerContext.events.length > 1;
    const isSelectingTimeBookerView =
        calBookerStep === CalBookerStep.SELECTING_TIME;
    const isConfirmationFormBookerView =
        calBookerStep === CalBookerStep.BOOKING;

    const singleEventBookerView =
        isSelectingTimeBookerView && !isMultipleEvents;
    const rescheduleUidBookerView =
        isSelectingTimeBookerView && bookingState.rescheduleUid;
    const selectedHostBookerView =
        isSelectingTimeBookerView && bookingState.selectedHostId;

    const shouldHideBackForSelection =
        singleEventBookerView && !selectedHostBookerView;
    const shouldHideBookerBack =
        !calBookerStep || shouldHideBackForSelection || rescheduleUidBookerView;
    // don't render back button if there are no events or if we are on the selecting time step and there is only one event
    if (shouldHideBookerBack) {
        return null;
    }

    const handleBack = () => {
        if (bookingState.selectedHostId) {
            bookingActions.setSelectedHostId(null);
        } else if (isSelectingTimeBookerView) {
            bookingActions.setEventSlug(null);
        } else if (isConfirmationFormBookerView) {
            bookingActions.resetBookerState();
        }
        bookingActions.resetEditorStep();
    };

    return (
        <span
            ref={(el) => {
                setRootEl(el?.closest(`.${containerClassName}`) as HTMLElement);
            }}
        >
            {rootEl && (
                <Portal rootEl={rootEl}>
                    <StyledBookerBackButton onClick={handleBack} />
                </Portal>
            )}
        </span>
    );
};

const StyledBookerBackButton = styled(BackButton)`
    && {
        margin-top: auto;
        padding-top: 16px;
        align-self: flex-start;
    }
`;

export default BookerBackButton;
